export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Close-78fdda5c3f80223e1f6878ba701181f9.svg";